import { useCallback } from 'react';
import {
  signInWithRedirect,
  getCurrentUser,
  signOut as signOutCognito,
  fetchAuthSession,
} from '@aws-amplify/auth';

import { UseAuthType } from '@core/auth/interfaces';

const useAuth: UseAuthType = () => {
  const signIn = useCallback(async () => {
    signInWithRedirect();
  }, []);

  const signOut = useCallback(async () => {
    signOutCognito({
      global: false,
      oauth: {
        redirectUrl: window.location.origin
      }
    });
  }, []);

  const authUser = useCallback(async () => {
    return await getCurrentUser();
  }, []);

  const getTokens = useCallback(async (options: any = {}) => {
    const session = await fetchAuthSession(options);
    return session?.tokens;
  }, []);

  return { signIn, signOut, getAuthTokens: getTokens, authUser };
};

export default useAuth;
